/**
 * src/components/footer/Footer.js
 *
 * Componente padre del footer. Orquesta brand, links, apps y barra de copyright.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { footerData } from '@/db/footer.db.js'

define('Footer', () => {
    const linkCols = footerData.linkGroups.map(group => c('FooterLinks', group))

    return h('footer', { className: 'site-footer' },
        h('div', { className: 'site-footer__inner' },
            c('FooterBrand', footerData.brand),
            ...linkCols,
            c('FooterApps', { apps: footerData.apps })
        ),
        c('FooterBottom', { copyright: footerData.copyright })
    )
})
